<template>
  <v-container 
    fluid 
    grid-list-md 
    text-xs-left
  >
    <v-layout justify-center>
      <v-progress-circular 
        v-show="loading"
        indeterminate
        color="primary"
        :size="50"
        :width="6">
      </v-progress-circular>
    </v-layout>
    <v-breadcrumbs 
      divider=">"
      :items="breadcrumbs"
    >
    </v-breadcrumbs>
    <ul v-show="errors && errors.length">
      <li 
        v-for="(error, i) in errors" 
        :key="i"
      >
        {{error.message}}
      </li>
    </ul>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap justify-space-around>
        <v-flex xs8>
          <DashboardHeader :editMode="editMode"></DashboardHeader>
          <v-layout row wrap>
            <v-flex xs12 v-if="dataset.dataset_id">
              <ReadMe :editMode="editMode"></ReadMe>
            </v-flex>
            <v-flex xs12 v-if="dataset.dataset_id">
              <License :editMode="editMode"></License>
            </v-flex>
            <v-flex xs12 v-if="dataset.dataset_id"> 
              <DataFormat :editMode="editMode"></DataFormat>
            </v-flex>
            <v-flex xs12 v-if="dataset.dataset_id"> 
              <Classification :editMode="editMode"></Classification>
            </v-flex>
          </v-layout>
          <v-layout row nowrap>
            <v-flex xs12>
              <TabVue 
                :dataset="dataset"
                :editMode="editMode"
              ></TabVue>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs3>
          <!--- Right side of screen -->
          <v-layout row nowrap>
            <v-flex xs12 v-if="dataset">
              <Sidebar 
                :dataset="dataset"
                :editMode="editMode"
              ></Sidebar>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only  -->
<style scoped>
.svgIcon {
  fill: #000000;
  stroke: #ff0000;
}
#textarea {
    display: none; /* hidden by default */
}

#textarea:target {
    display: block; /* shown when a link targeting this id is clicked */
}

#textarea + ul.controls {
    list-style-type: none; /* aesthetics only, adjust to taste, irrelevant to demo */
}

/* hiding the hide link when the #textarea is not targeted,
   hiding the show link when it is selected: */
#textarea + ul.controls .hide,
#textarea:target + ul.controls .show {
    display: none;
}

/* Showing the hide link when the #textarea is targeted,
   showing the show link when it's not: */
#textarea:target + ul.controls .hide,
#textarea + ul.controls .show {
    display: inline-block;
}
</style>

<script>
import TabVue from './TabVue.vue'
import Sidebar from './Sidebar.vue'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import License from './License.vue'
import DataFormat from './DataFormat.vue'
import ReadMe from './ReadMe.vue'
import Classification from './Classification.vue'
import DashboardHeader from './DashboardHeader.vue'

export default {
  components: {
    TabVue,
    Sidebar,
    License,
    DataFormat,
    ReadMe,
    Classification,
    DashboardHeader
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: [],
      fillBarNum: 0,
      key: 0,
      items: [
        'item1',
        'item2',
        'item3'
      ],
      loading: true,
      svgTest: 'm 47.998,58.392 c 11.951,0 21.955,-4.061 22.561,-9.362 -1.777,-4.985 -3.715,-10.421 -5.619,-15.764 -1.322,3.811 -8.623,6.498 -16.941,6.498 -8.316,0 -15.617,-2.688 -16.941,-6.497 -1.904,5.342 -3.84,10.777 -5.617,15.763 0.604,5.301 10.606,9.362 22.557,9.362 z m 0,-33.526 c 5.617,0 10.836,-1.739 12.363,-4.439 C 58.256,14.514 56.447,9.441 55.304,6.24 54.545,4.107 51.103,2.999 47.998,2.999 c -3.105,0 -6.547,1.108 -7.307,3.241 -1.141,3.201 -2.949,8.274 -5.057,14.187 1.528,2.7 6.749,4.439 12.364,4.439 z m 43.904,38.465 -18.777,-7.563 2.162,6.033 C 75.178,68.195 62.766,73.29 47.998,73.29 33.232,73.29 20.818,68.195 20.711,61.801 l 2.16,-6.033 -18.775,7.563 c -5.264,2.121 -5.484,6.049 -0.49,8.726 l 35.312,18.935 c 4.994,2.677 13.168,2.677 18.162,0 L 92.392,72.057 c 4.995,-2.677 4.774,-6.605 -0.49,-8.726 z'
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'getDatasetKey',
      'getTopLevelFields',
      'getPresentMode',
      'getUser',
    ]),
    dataset () {
      return this.getCurrentDataset
    },
    breadcrumbs () {
      return [
        {
          text: 'Overview',
          to: '/',
          disabled: false
        },
        {
          text: `Dataset ${this.getCurrentDataset.dataset_id}`,
          to: '#',
          disabled: true
        }
      ]
    }
  },
  watch: {
    '$route' (route) {
      if (route.name === 'DatasetEdit') {
        this.loading = true
        this.getDatasetAction(this.getDatasetKey)
          .then(() => this.loading = false)
      }
    }
  },
  mounted () {
    this.setDatasetKey(this.$route.params.key)
    this.getDatasetAction(this.getDatasetKey)
      .then(() => {
        this.loading = false
        if (this.$store.getters.getCurrentDataset.dataset_pi
          .some(item => item.email_address === this.getUser.username)) {
          this.$store.commit('setIsUserPI', true)
        } else {
          this.$store.commit('setIsUserPI', false)
        }
      })
      .catch((e) => {
        this.logError(e)
        this.$router.push('/')
      })
  },
  methods: {
    ...mapActions([
      'getDatasetAction'
    ]),
    ...mapMutations([
      'setView',
      'logError',
      'setDatasetEdit',
      'setDatasetKey',
      'getIsUserPI'
    ]),
    saveDataset () {
      const payload = {
        data: { ...this.getDatasetEdits }
      }
      this.$store.dispatch('saveDatasetAction', payload)
    }
  }
}
</script>